(function () {
    function initGallery(root) {
        if (root.dataset.pvGalleryReady === 'true') return;
        root.dataset.pvGalleryReady = 'true';

        const track = root.querySelector('[data-pv-gallery-track]');
        if (!track) return;

        const slides = Array.from(track.children);
        const thumbs = Array.from(root.querySelectorAll('[data-pv-gallery-thumb]'));
        const prev = root.querySelector('[data-pv-gallery-prev]');
        const next = root.querySelector('[data-pv-gallery-next]');
        const counter = root.querySelector('[data-pv-gallery-counter]');
        let current = -1;

        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        let lockUntil = 0;

        function goTo(index, behavior) {
            const clamped = Math.max(0, Math.min(index, slides.length - 1));
            const target = slides[clamped].offsetLeft - track.offsetLeft;
            lockUntil = Date.now() + 600;
            setActive(clamped);
            if (Math.abs(track.scrollLeft - target) < 1) return;

            if (behavior === 'instant' || reducedMotion.matches) {
                track.scrollTo({ left: target, behavior: 'instant' });
                return;
            }

            const from = track.scrollLeft;
            track.scrollTo({ left: target, behavior: 'smooth' });
            setTimeout(function () {
                if (track.scrollLeft === from && Math.abs(track.scrollLeft - target) >= 1) {
                    track.scrollTo({ left: target, behavior: 'instant' });
                }
            }, 300);
        }

        function revealThumb(index) {
            const strip = root.querySelector('[data-pv-gallery-thumbs]');
            const thumb = thumbs[index];
            if (!strip || !thumb) return;
            const stripRect = strip.getBoundingClientRect();
            const thumbRect = thumb.getBoundingClientRect();
            if (strip.scrollWidth > strip.clientWidth) {
                const offset = thumbRect.left - stripRect.left - (stripRect.width - thumbRect.width) / 2;
                strip.scrollLeft = strip.scrollLeft + offset;
            } else if (strip.scrollHeight > strip.clientHeight) {
                const offset = thumbRect.top - stripRect.top - (stripRect.height - thumbRect.height) / 2;
                strip.scrollTop = strip.scrollTop + offset;
            }
        }

        function setActive(index) {
            if (index === current) return;
            current = index;
            thumbs.forEach(function (thumb, i) {
                thumb.setAttribute('aria-current', i === index ? 'true' : 'false');
            });
            revealThumb(index);
            if (counter) counter.textContent = index + 1 + '/' + slides.length;
            if (prev) prev.disabled = index === 0;
            if (next) next.disabled = index === slides.length - 1;
            slides.forEach(function (slide, i) {
                if (i === index) return;
                const video = slide.querySelector('video');
                if (video && !video.paused) video.pause();
            });
        }

        const observer = new IntersectionObserver(
            function (entries) {
                if (Date.now() < lockUntil) return;
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) setActive(slides.indexOf(entry.target));
                });
            },
            { root: track, threshold: 0.6 }
        );
        slides.forEach(function (slide) {
            observer.observe(slide);
        });

        thumbs.forEach(function (thumb) {
            thumb.addEventListener('click', function () {
                goTo(parseInt(thumb.dataset.pvGalleryThumb, 10));
            });
        });

        if (prev) {
            prev.addEventListener('click', function () {
                goTo(current - 1);
            });
        }
        if (next) {
            next.addEventListener('click', function () {
                goTo(current + 1);
            });
        }

        track.addEventListener('keydown', function (event) {
            if (event.key === 'ArrowRight') {
                event.preventDefault();
                goTo(current + 1);
            } else if (event.key === 'ArrowLeft') {
                event.preventDefault();
                goTo(current - 1);
            }
        });

        setActive(0);

        bindVariantSync(root, slides, goTo);
    }

    function bindVariantSync(root, slides, goTo) {
        const dataNode = root.querySelector('[data-pv-gallery-variant-media]');
        if (!dataNode) return;

        let map;
        try {
            map = JSON.parse(dataNode.textContent);
        } catch (error) {
            return;
        }

        const scope = root.closest('[x-data]') || document;
        const idInput = scope.querySelector('input[name="id"]');
        if (!idInput) return;

        let lastId = null;

        function sync(behavior) {
            const value = idInput.value;
            if (!value || value === lastId) return;
            lastId = value;
            const mediaId = map[value];
            if (!mediaId) return;
            const index = slides.findIndex(function (slide) {
                return slide.dataset.mediaId === String(mediaId);
            });
            if (index >= 0) goTo(index, behavior);
        }

        sync('instant');

        scope.addEventListener('click', function (event) {
            if (!event.target.closest('.pv-variant__option')) return;
            requestAnimationFrame(function () {
                requestAnimationFrame(function () {
                    sync();
                });
            });
        });
    }

    function initAll() {
        document.querySelectorAll('[data-pv-gallery]').forEach(initGallery);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAll);
    } else {
        initAll();
    }

    document.addEventListener('shopify:section:load', initAll);
})();
